import Logo from "@/components/logo/logo-component";
import { useAdvancedFeatures } from "@/hooks/use-advanced-features";

import { FooterWrapper } from "./footer-component-styles";

export default function Footer() {
  const { advancedFeaturesEnabled } = useAdvancedFeatures();

  if (advancedFeaturesEnabled) {
    return null;
  }

  return (
    <FooterWrapper>
      <Logo />
    </FooterWrapper>
  );
}
